import { Switch } from 'ui/switch';

import { INSIGHT_MODAL_NAVIGATE_REQUEST } from 'components/partials/insight-modal/shared/constants';

import type { GoalRecord } from 'components/partials/insight-modal/report/hooks';

interface GoalCellContext {
  row: { original: GoalRecord };
}

export const buildReportRelatedGoalsTableSettings = (
  linkedGoals: Array<string | number> | GoalRecord[],
  handleToggleChange: (goal: GoalRecord, isOn: boolean) => void,
  isToggling: boolean,
  clientId: string | number | undefined
) => {
  const commonStyles = 'pl-4 border-r-2 border-white font-semibold h-8';

  return [
    {
      header: () => <span>CATEGORY</span>,
      accessorKey: 'category',
      headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
      className: 'pl-4 py-3 tablet:w-[30%] font-semibold',
      enableSorting: false,
    },
    {
      header: () => <span>DESCRIPTION</span>,
      accessorKey: 'description',
      headerClassName: commonStyles,
      className: 'pl-4 py-3 tablet:w-[50%]',
      enableSorting: false,
      cell: ({ row }: GoalCellContext) => {
        const goal = row.original;
        const goalText = goal.summary;
        const goalLink = `/admin/clients/${clientId}/goals/${
          goal.enteringClassYear
        }/${goal.type?.toLowerCase()}/${goal.category?.toLowerCase()}/${
          goal.id
        }`;

        const handleGoalLinkClick = (
          e: React.MouseEvent<HTMLAnchorElement>
        ) => {
          e.preventDefault();
          window.dispatchEvent(
            new CustomEvent(INSIGHT_MODAL_NAVIGATE_REQUEST, {
              detail: { url: goalLink },
            })
          );
        };

        return (
          <a
            href={goalLink}
            className="text-blue-700 underline"
            onClick={handleGoalLinkClick}
          >
            {goalText}
          </a>
        );
      },
    },
    {
      header: () => <span>LINK</span>,
      id: 'link',
      headerClassName: `${commonStyles} rounded-tr-md rounded-br-md`,
      className: 'pl-4 py-3 tablet:w-[20%]',
      isHeaderCentered: true,
      enableSorting: false,
      cell: ({ row }: GoalCellContext) => {
        const goal = row.original;

        const isArrayOfIds =
          Array.isArray(linkedGoals) &&
          linkedGoals.length > 0 &&
          typeof linkedGoals[0] !== 'object';

        const isLinked = isArrayOfIds
          ? goal.id !== undefined &&
            (linkedGoals as Array<string | number>).includes(goal.id)
          : (linkedGoals as GoalRecord[]).some((g) => g.id === goal.id);

        return (
          <div className="flex justify-center">
            <Switch
              aria-label={`Link ${goal.summary || goal.category || 'goal'}`}
              checked={isLinked}
              onChange={(_event, checked) => handleToggleChange(goal, checked)}
              disabled={isToggling}
              data-testid="relative-goals-table-toggle"
            />
          </div>
        );
      },
    },
  ];
};
